import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-app-route-update',
  templateUrl: './app-route-update.component.html',
  styleUrls: ['./app-route-update.component.scss']
})
export class AppRouteUpdateComponent implements OnInit {
  variable_code_block_id: number;
  app_route_id: number;

  constructor(private route: ActivatedRoute) { 
    // this.variable_code_block_id = +this.route.snapshot.paramMap.get('variable_code_block_id');
    this.app_route_id = +this.route.snapshot.paramMap.get('app_route_id');
    
  }

  ngOnInit(): void {
  }

}
